@tailwind base;
@tailwind components;
@tailwind utilities;

:root {
	--eF-theme-color: #19cc76;
	--eF-theme-accent: #142f48;
	--eF-theme-h-text: #142f48;
	--eF-hover-color: #16ac6b;
	--eF-bullet-bg: #bbf7d0;
}

select {
	appearance: none;
	background-image: url("data:image/svg+xml,%3Csvg%20xmlns='http://www.w3.org/2000/svg'%20fill='none'%20viewBox='0%200%2020%2020'%3E%3Cpath%20stroke='%236b7280'%20stroke-linecap='round'%20stroke-linejoin='round'%20stroke-width='1.5'%20d='M6%208l4%204%204-4'/%3E%3C/svg%3E");
	background-position: right 0.5rem center;
	background-repeat: no-repeat;
	background-size: 1.5em 1.5em;
	padding-right: 2.5rem;
	-webkit-print-color-adjust: exact;
	print-color-adjust: exact;
}
